var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileAdd = function SvgFileAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m25.954 8.74-1.069-7.085H9.202c-2.362 0-4.237 1.924-4.237 4.286v29.657a4.218 4.218 0 0 0 4.237 4.246h14.877l10.718-16.228V12.043L25.954 8.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "m24.886 1.665 9.882 10.378H28.19a3.301 3.301 0 0 1-3.304-3.304V1.665Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.506 23.908H11.845a.975.975 0 0 0-.972.972c0 .534.438.971.972.971h12.661a.975.975 0 0 0 .972-.971.968.968 0 0 0-.972-.972ZM11.845 20.992h9.843a.975.975 0 0 0 .972-.971.975.975 0 0 0-.972-.972h-9.843a.975.975 0 0 0-.972.972c0 .534.438.971.972.971ZM21.31 28.864h-9.465a.975.975 0 0 0-.972.971c0 .535.438.972.972.972h9.464a.975.975 0 0 0 .972-.972.975.975 0 0 0-.972-.971Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#file_add_svg__a)",
    d: "M35.775 23.225c5.65.792 9.997 5.638 9.997 11.505 0 6.413-5.204 11.615-11.62 11.615-4.41 0-8.256-2.46-10.215-6.085a11.594 11.594 0 0 1-1.404-5.54c0-6.412 5.204-11.614 11.62-11.614.547.01 1.084.046 1.622.119Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M33.905 28.47c-.686 0-1.242.555-1.242 1.24v3.228h-3.227c-.686 0-1.242.556-1.242 1.242v.496c0 .686.556 1.242 1.242 1.242h3.227v3.227c0 .686.556 1.242 1.242 1.242h.496c.686 0 1.242-.556 1.242-1.242v-3.227h3.227c.686 0 1.242-.556 1.242-1.242v-.496c0-.686-.556-1.242-1.242-1.242h-3.227v-3.227c0-.686-.556-1.242-1.242-1.242h-.496Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_add_svg__a",
    x1: 34.153,
    x2: 34.153,
    y1: 23.106,
    y2: 46.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })))));
};
export default SvgFileAdd;